export default "__VITE_ASSET__Dz2G7l$8__"